// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const isObject = (value: any): boolean => Object.prototype.toString.call(value) === '[object Object]';

// Flow compatible alternative for Object.keys()
// https://github.com/facebook/flow/issues/2221#issuecomment-372112477
export const keys = <T>(obj: { [key: string]: T }): Array<string> => Object.keys(obj);
export const values = <T>(obj: { [key: string]: T }): Array<T> => Object.keys(obj).map((k) => obj[k]);

export const numberKeys = <T>(obj: { [key: string]: T }): Array<number> => {
  const tempKeys = keys(obj);
  const numKeys = [];
  for (let i = 0; i < tempKeys.length; i += 1) {
    numKeys[i] = parseInt(tempKeys[i], 10);
  }
  return numKeys;
};

export const safeParseJson = (value: string) => {
  try {
    return JSON.parse(value);
  } catch {
    return null;
  }
};

// Transform an array of objects to a map-like object keyed by the specified key
export function keyBy<T, K extends keyof T>(array: T[], key: K): Record<string, T> {
  return array.reduce(
    (accumulator, currentItem) => {
      // Convert the key value to a string to safely use as an object key
      const keyValue = String(currentItem[key]);
      accumulator[keyValue] = currentItem;
      return accumulator;
    },
    {} as Record<string, T>,
  );
}
